/**
 * Company list configuration.
 * Extracted from CompaniesList.tsx to enable generic listing component.
 *
 * Uses declarative column definitions with kind field:
 * - kind: 'object_name' - Renders avatar + display name together
 * - kind: 'property' - Renders property value using PropertyValueLabel
 * - kind: 'association' - Renders associated objects using CrmObjectTagGroup
 */

import type { ListPageConfig } from '../../core/types';
import { getEntityTypeCreateConfig } from '../../record/registry/entityTypeRegistry';

const createConfig = getEntityTypeCreateConfig('ahoy_company');

export const companyListConfig: ListPageConfig = {
  entityType: 'ahoy_company',
  title: 'Company',
  pluralTitle: 'Companies',

  // Column configuration for table view - declarative format
  // Labels are derived from property/association schemas
  columns: [
    { kind: 'object_name', sortable: true, width: 280 },
    { kind: 'association', name: 'ahoy_company_to_contact' },
    { kind: 'association', name: 'ahoy_company_to_deal' },
    { kind: 'property', name: 'ahoy_updated_at' },
  ],

  // Properties and associations from registry (single source of truth)
  createProperties: createConfig?.createProperties ?? [],
  createAssociations: createConfig?.createAssociations ?? [],

  // Metrics configuration
  metrics: [],

  // Default filters
  defaultFilters: {
    sort: 'ahoy_name',
    order: 'asc',
    page: 1,
    page_size: 20,
  },

  // UI configuration
  tabs: [{ id: 'table', label: 'All Companies' }],
  defaultTab: 'table',
  showTimeFilter: false,
};
